import * as React from 'react';

const useClickOutside = (ref: React.RefObject<HTMLElement>, shouldListen: boolean, callback: () => void) => {
	React.useEffect(() => {
		if (!shouldListen) {
			return;
		}

		const handleClickOutside = (e: MouseEvent | TouchEvent) => {
			if (ref.current && !ref.current.contains(e.target as HTMLElement)) {
				callback();
			}
		};

		window.addEventListener('pointerdown', handleClickOutside);

		return () => {
			window.removeEventListener('pointerdown', handleClickOutside);
		};
	}, [ref, shouldListen, callback]);
};

export default useClickOutside;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/customHooks/useClickOutside.ts